export default __webpack_public_path__ + "3c60402ec218dca97922d7618d9e6d75.svg";